import React, { useState } from 'react'
import { COMPANY_LOGO_BASE_URL } from '../../../config/apiConfig';

export default function AccountLogo({account_name}) {

    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    return (
    <div 
        className="com_logo"
        key={`account_img_div_${account_name}`}
        style={{
            width: "100px",
            height: "100px",
            backgroundColor: !isLoaded ? "#e0e0e0" : "transparent",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: '9px',
            marginBottom: '9px',
            marginTop: '9px'
      }}
        >
        {!hasError && (
        <img
          key={`account_img_${account_name}`}
          src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(account_name)}`}
          alt={account_name}
          className={`icon ${isLoaded ? "loaded" : ""}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: isLoaded ? "block" : "none",
            transition: "opacity 0.3s ease-in",
            opacity: isLoaded ? 1 : 0,
          }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  )
}
